// 计时器

var tickerId = 1

function Ticker(step) {
  step = step || 1000
  this.step = Math.max(0, step)
  this.id = 'ticker' + tickerId++
  this.isRunning = false
  this.timestamp = 0
  this.stepTimeout = 0
  this.stepTimer = null
  this.cbs = []
}

Ticker.prototype.nextTick = function() {
  var _this = this

  this.stepTimer = setTimeout(function() {
    if (!_this.isRunning) {
      return false
    }
    for (var i = 0; i < _this.cbs.length; ++i) {
      _this.cbs[i](_this.timestamp + _this.stepTimeout)
    }
    var currentTime = Date.now()
    _this.stepTimeout = _this.step + (_this.timestamp + _this.stepTimeout - currentTime)
    _this.timestamp = currentTime
    _this.nextTick()
  }, this.stepTimeout)
}

Ticker.prototype.start = function() {
  if (this.isRunning) {
    return true
  }
  this.isRunning = true
  this.timestamp = Date.now()
  this.stepTimeout = this.step
  this.nextTick()
  return true
}

Ticker.prototype.addTicking = function(cb) {
  this.cbs.push(cb)
}

Ticker.prototype.clearTicking = function(cb) {
  if (cb) {
    for (var i = 0; i < this.cbs.length; ++i) {
      if (cb === this.cbs[i]) {
        this.cbs.splice(i, 1)
        break
      }
    }
  } else {
    this.cbs.splice(0, this.cbs.length)
  }
}

Ticker.prototype.stop = function() {
  this.isRunning = false
  clearTimeout(this.stepTimer)
  this.stepTimer = null
}

var globalTickers = Object.create(null)

export function setTicker(cb, step) {
  var ticker = new Ticker(step)
  ticker.addTicking(cb)
  globalTickers[ticker.id] = ticker
  ticker.start()
  return ticker.id
}

export function clearTicker(tickerId) {
  var ticker = globalTickers[tickerId]
  if (ticker) {
    ticker.stop()
    ticker.clearTicking()
    globalTickers[tickerId] = null
  }
}
